import { Command } from 'commander';
import { ApiClient } from '../client.js';
import { formatOutput } from '../output.js';
import { getDatabase, getFormat } from '../helpers.js';

export const queryRelationshipsCommand = new Command('query-relationships')
  .description('Query related documents')
  .argument('<collection>', 'Collection of the source document')
  .argument('<id>', 'Source document ID')
  .option('--type <type>', 'Filter by relationship type')
  .option('--direction <dir>', 'Direction: outgoing, incoming, or both', 'both')
  .option('--limit <n>', 'Max results', '50')
  .option('--offset <n>', 'Skip results', '0')
  .action(async function (this: Command, collection: string, id: string, opts: { type?: string; direction: string; limit: string; offset: string }) {
    const ws = getDatabase(this);
    const client = new ApiClient();
    const params = new URLSearchParams();
    if (opts.type) params.set('rel_type', opts.type);
    // Map user-friendly direction names to backend API terms
    const directionMap: Record<string, string> = { outgoing: 'source', incoming: 'target', both: 'both' };
    params.set('direction', directionMap[opts.direction] ?? opts.direction);
    params.set('limit', opts.limit);
    params.set('offset', opts.offset);
    const data = await client.request('GET', `/v1/${ws}/documents/${collection}/${id}/related?${params.toString()}`);
    console.log(formatOutput(data, getFormat(this)));
  });
